import React, {useState} from 'react';
import * as Select from "@radix-ui/react-select";
import styled from "styled-components";
import * as ScrollArea from "@radix-ui/react-scroll-area";


const ComboBox = ({placeholder = "Choose One...",items=[], onChange,defaultValue,value,disabled,className='gne-atoms__combobox'}) => {
  if (!onChange) {
    throw new Error("onChange is a required prop");
  }

  const [open, setOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const resolvedItems=items.map((item,index)=>({
    id: String(item?.id ?? index),
    name:item?.name ?? item,
  }))

  const filteredItems = resolvedItems.filter(item => item.name?.toLowerCase().includes(searchQuery?.toLowerCase()));
  const handleValueChange = (newValue) => {
    onChange(newValue)
    setSearchQuery('')
  };

  return (
    <DropdownContainer className={className}>
      <Select.Root
        onValueChange={handleValueChange}
        open={open}
        value={value}
        disabled={disabled}
        onOpenChange={setOpen}>
        <StyledTrigger asChild className={`select-trigger ${disabled ? 'disabled' : ''} ${className}`}>
        <IconButton aria-label={`Select ${placeholder}`} disabled={disabled}>
        <Select.Value placeholder={defaultValue||placeholder}/> 
        <StyledIcon>
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 9l6 6 6-6" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </StyledIcon>
        </IconButton>
        </StyledTrigger>
        <Select.Portal>
          <StyledContent position="popper" sideOffset={5} className={className}>
            <div className="combobox-wrapper">
              <input
                type="text"
                placeholder="Search..."
                className="combobox-input"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyDown={(e) => e.stopPropagation()}
              />
            </div> 
            <ScrollArea.Root className="combobox-wrapper">
            <ScrollArea.Viewport>
            <StyledViewPort>
              {filteredItems.length > 0 ?(
              filteredItems.map(item => (
             <StyledSelectItem key={item.id} value={item.name} className="item">
              <Select.ItemText>{item.name}</Select.ItemText>
            </StyledSelectItem>
             ))
            ):(
              <>No results found</>
            )}
            </StyledViewPort>
            </ScrollArea.Viewport>
            </ScrollArea.Root>
          </StyledContent>
        </Select.Portal>
      </Select.Root>
    </DropdownContainer>
  );
};

const DropdownContainer = styled.div`
  width: 100%;
  z-index: 1000;
  position: relative;

  .mmm-dropdown{
    z-index:10000;
    position:relative;
  }


  @media (max-width: 1024px) {
    .mmm-dropdown{
      z-index:10000;
      width:100%;
      position:relative;
    }
  }

`;

const StyledTrigger = styled(Select.Trigger)`
  width: 100%;
  display:flex;

  .select-trigger.disabled{
    opacity: 0.5;
    pointer-events: none;
  }

  .mmm-dropdown{
    width:100%;
    z-index:10000;
  }
  
`;

const IconButton = styled.button`
  width:100%;
  background-color: var(--color--white);
  color: var(--color--dark-grey);
  padding: 10px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  white-space: nowrap;
  font-size: 16px;

  &:hover {
    background-color: var(--color--dark-grey);
    color: var(--color--white);
  }
  
  &:disabled {
    cursor: not-allowed;
     padding:10px;
    border:none;
  }
`;

const StyledIcon = styled(Select.Icon)`
 margin-left: 10px;
  svg{
    width:8%;
    margin-left:90%;
    fill:none;
    stroke:var(--color--dark-grey);
    stroke-width:1;
  }
`;

const StyledContent = styled(Select.Content)`
  background-color: var(--color--white);
  border: 1px solid var(--color--medium-grey);
  color: var(--color--black);
  border-radius: 8px;
  padding: 10px 0;
  width: var(--radix-select-trigger-width);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index:10000;


  .combobox-wrapper {
    padding: 5px;
    border-bottom: 1px solid var(--color--medium-grey);
  }

  .combobox-input {
    width: 100%;
    padding: 5px 10px;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    color:var(--color--black);
  }
  

`;

const StyledSelectItem = styled(Select.Item)`
  padding: 10px 20px;
  font-size: 14px;
  color: var(--color--black);
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--color--white);

  &[data-highlighted] {
    background-color: var(--color--dark-grey);
    color: var(--color--black);
  }

`;

const StyledViewPort = styled(Select.Viewport)`
overflow-y:hidden;
 max-height: 400px;

`;

export default ComboBox;

